export default{
    root: {
        backgroundColor: 'rgb(0 0 0 / 6%)',
    },
};